var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"border-title  font-s24 c33"},[_vm._v(_vm._s(_vm.list.title))]),_c('div',{staticClass:"font-s14 c66",domProps:{"innerHTML":_vm._s(_vm.list.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }